import React from "react";
import { NavItem, NavLink } from "reactstrap";
import styled from "styled-components";

const LINK_COLORS = {
  true: "#0078a8",
  false: "#333333",
};

const LINK_BORDER_BOTTOM = {
  true: "4px solid #0078a8",
  false: "none",
};

const Link = styled(NavLink)`
  font-size: 0.875rem;
  color: ${(props) => LINK_COLORS[props.active]};
  &:hover {
    color: #0078a8;
  }
  padding: 0;
  padding-bottom: 0.75rem;
  text-align: left;
  border-bottom: ${(props) => LINK_BORDER_BOTTOM[props.active]};
`;

const TabLink = ({ children, active = false, onClick }) => {
  return (
    <NavItem>
      <Link active={active} onClick={onClick} href="#">
        {children}
      </Link>
    </NavItem>
  );
};

export default TabLink;
